namespace $.$$ {
	export class $shm_file_drop extends $.$shm_file_drop {
		@ $mol_mem
		drag_depth( next?: number ) {
			return next ?? 0
		}

		drop_title() {
			return this.drag_active() ? 'Отпустите для загрузки' : 'Перетащите файл'
		}

		drag_files( event: DragEvent ) {
			return Array.from( event.dataTransfer?.types ?? [] ).includes( 'Files' )
		}

		@ $mol_action
		drag_enter( next?: DragEvent ) {
			if( !next || !this.drag_files( next ) ) return next ?? null
			next.preventDefault()
			this.drag_depth( this.drag_depth() + 1 )
			this.drag_active( true )
			return next
		}

		@ $mol_action
		drag_over( next?: DragEvent ) {
			if( !next || !this.drag_files( next ) ) return next ?? null
			next.preventDefault()
			if( next.dataTransfer ) next.dataTransfer.dropEffect = 'copy'
			return next
		}

		@ $mol_action
		drag_leave( next?: DragEvent ) {
			if( !next || !this.drag_active() ) return next ?? null
			const depth = Math.max( 0, this.drag_depth() - 1 )
			this.drag_depth( depth )
			if( !depth ) this.drag_active( false )
			return next
		}

		@ $mol_action
		file_drop( next?: DragEvent ) {
			if( !next ) return null
			next.preventDefault()
			this.drag_depth( 0 )
			this.drag_active( false )
			const files = [ ... ( next.dataTransfer?.files ?? [] ) ]
			if( files.length ) this.files( files.slice( 0, 1 ) )
			return next
		}
	}
}
